import angular from 'angular';
import uiRouter from 'angular-ui-router';
import benefitRequestModalComponent from './benefitRequestModal.component';

import modalRejectRequest from './modalRejectRequest/modalRejectRequest';
import modalSendAllCards from './modalSendAllCards/modalSendAllCards';
import managerRequestAll from './managerAcceptAll/managerAcceptAll';

let benefitRequestModalModule = angular.module('benefitRequestModal', [
  uiRouter,
  modalRejectRequest,
  modalSendAllCards,
  managerRequestAll,
])

.component('benefitRequestModal', benefitRequestModalComponent)

.name;

export default benefitRequestModalModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/benefitRequestModal.js